<template>
  <div class="wrapper">
      <w-header class="gradual-top" slot="top" title="365汽车在线" :logo="headLogo" tip="" :tools="tools">
      </w-header>
    <w-gradual :style="gradualStyle" :imgs="pics">

      <w-login v-if="allReset" @login="login" :loading="btnLoading" slot="login" :demo-visible="config.demoVisible" :demo-url="config.demoUrl"
        :style="loginStyle" ref="login" :error-delay="8000">
      </w-login>
    </w-gradual>
    <div class="middle" v-if="false">
      <h1 class="title">我们的服务</h1>
      <w-split gap="0" align="120px" vertical></w-split>
      <w-flex :flex-items="flexItems"></w-flex>
    </div>
    <w-footer class="w-footer" v-if="allReset">
      <w-footer-line>  &nbsp; </w-footer-line>
      <!-- <w-footer-line>
        <a :href="config.companyLink">{{config.companyTitle}}</a>
        <w-split v-if="false" gap="8px" align="14px" color="#909399"></w-split>
        <span>{{config.companyAddress}}</span>
      </w-footer-line>
      <w-footer-line>
        <span>Version 4.0 Build.20180417</span>
        <w-split gap="8px" align="14px" color="#909399"></w-split>
        <span>Copyright © 2009-2018 All Rights Reserved</span>
        <w-split gap="8px" align="14px" color="#909399"></w-split>
        <a :href="config.gswjUrl" target="_blank">
          <img :src="config.gswjImgSrc" class="gswj" />
        </a>
        <a href="http://www.miitbeian.gov.cn/" target="_blank">
          {{config.icp}}
        </a>
      </w-footer-line> -->
    </w-footer>
  </div>
</template>

<script>
  import './config/components'
  import { setToken, removeToken } from '@/common/auth'
  import { mapMutations } from 'vuex'

  import WFlex from './config/w-flex'
  import WFooterLine from './config/w-footer-line'
  import WFooter from './config/w-footer'
  import WGradual from './config/w-gradual'
  import WHeader from './config/w-header'
  import WLogin from './config/w-login'
  import WSplit from './config/w-split'
  import WToolItem from './config/w-tool-item'

  import { Login } from '@/api/login'

  export default {
    components: {
      WFlex,
      WFooterLine,
      WFooter,
      WGradual,
      WHeader,
      WLogin,
      WSplit,
      WToolItem
    },
    data() {
      return {
        allReset: false,
        gradualStyle: { height: 'auto' },
        loginStyle: { right: 'auto', top: '100px' },
        btnLoading: false,
        config: {
          logo: '',
          title: '',
          wechatImg: '',
          iosImg: '',
          androidImg: '',
          banner: [],
          companyTitle: '',
          companyLink: '',
          companyPhone: '',
          companyAddress: '',
          icp: '粤ICP备09213828号-3',
          certId: 'ca5f63b3-0682-4acd-93a1-22920b2dac33',
          gswjUrl: '',
          gswjImgSrc: '',
          demoVisible: true,
          demoUrl: ''
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize_1)
      window.removeEventListener('resize', this.resize_2)
    },
    created: function () {

      // 滚动图
      this.pics = [
        require('../../assets/船.jpg'),
        // require('../../../assets/banner1.jpg')
      ]
      this.headLogo = require('../../assets/Logo_White.png')
      // 初始化配置信息
      const currentConfig = require('./config/config.json').default; // eslint-disable-line
      // console.log(currentConfig)
      this.config = Object.assign({}, this.config, currentConfig);



      //const correctPixel = 4
      const minRight = 40
      let minWidth = window.innerWidth < 1250 ? 1250 : window.innerWidth
      this.gradualStyle.height = (minWidth) / 1920 * 700 + 'px';
      //console.log('初始高度', this.gradualStyle.height)
      this.resize_1 = () => {
        let minWidth = window.innerWidth < 1250 ? 1250 : window.innerWidth
        this.gradualStyle.height = (minWidth) / 1920 * 700 + 'px';
        //console.log('计算高度', this.gradualStyle.height)
      }
      window.addEventListener('resize', this.resize_1);

      const right = (minWidth - 1250) / 2;
      this.loginStyle.right = (right < minRight ? minRight : right) + 'px';
      this.loginStyle.top = (parseInt(this.gradualStyle.height, 10) - 370) / 2 + 'px';
      //console.log('初始右边距,上边距', this.gradualStyle.right, this.loginStyle.top)
      this.resize_2 = () => {
        let minWidth = window.innerWidth < 1250 ? 1250 : window.innerWidth
        const right = (minWidth - 1250) / 2;
        this.loginStyle.right = (right < minRight ? minRight : right) + 'px';
        this.loginStyle.top = (parseInt(this.gradualStyle.height, 10) - 370) / 2 + 'px';
        //console.log('计算右边距,上边距', this.gradualStyle.right, this.loginStyle.top)
      }
      window.addEventListener('resize', this.resize_2);













      this.flexItems = [
        { img: 'icon-iconfontsiglyphpinlocation2', title: '轻松管理车辆', comments: ['自助管理', '便捷定位', '轨迹回放', '丰富报表'], css: 'position' },
        { img: 'icon-xiangao', title: '专业金融风控', comments: ['贷前评估', '风险监控', '贷后找车'], css: 'report' },
        { img: 'icon-SIMqiaguanli', title: 'SIM管理服务', comments: ['余额查询', '自助充值', '短信发送'], css: 'sim' },
        { img: 'icon-185096settingsstreamline', title: '贴身定制开发', comments: ['协议接入', '开放接口', '个性定制'], css: 'setting' },
      ];

      this.tools = [
        { name: '微信', icon: 'icon-weixin', remark: '关注微信公众号', img: this.config.wechatImg, link: '' },
        { name: 'IOS', icon: 'icon-ios', remark: '下载IOS APP', img: this.config.iosImg, link: 'http://app.365qczx.com/applink.html' },
        { name: 'Android', icon: 'icon-android', remark: '下载Android APP', img: this.config.androidImg, link: 'http://app.365qczx.com/applink.html' }
      ];

      //document.title = this.config.title;
      // 工商网监
      //this.initGSWJ();
    },
    mounted: function () {
      this.allReset = true;
    },
    methods: {
      // 登录在这写
      login: function (form) {

        this.$refs.login.error = ''

        if (!form.username) {
          this.$nextTick(() => {
            this.$refs.login.error = 'Login failed. UserName required.'
          })
          return
        }
        if (!form.password) {
          this.$nextTick(() => {
            this.$refs.login.error = 'Login failed. Password required.'
          })
          return
        }

        this.btnLoading = true;
        //console.log(form);

        Login(form.username, form.password).then(ret => {

          // console.log(ret)

          if (!ret.data.errCode) {
            setToken(ret.data.loginKey)
            this.$router.push('/home')
            this.setUserName(ret.data.info.LoginName) // 登录用户名
            this.setUserId(ret.data.info.UserID) // 登录用户ID
            this.setLoginInfo(ret.data.info) // 保存登录全部信息
          } else {
            removeToken()
            this.$refs.login.error = ret.data.errMsg
          }
          this.btnLoading = false

        }).catch(err => {
          this.$refs.login.error = err.message
          this.btnLoading = false
        })

        this.timer = setTimeout(() => {
          this.btnLoading = false;
        }, 5000);
      },
      setCookie: function (name, value) {
        //cookies设置JS
        var argv = arguments;
        var argc = arguments.length;
        var expires = (argc > 2) ? argv[2] : null;
        if (expires != null) {
          var LargeExpDate = new Date();
          LargeExpDate.setTime(LargeExpDate.getTime() + (expires * 1000 * 3600 * 24));
        }
        document.cookie = name + "=" + value + ((expires == null) ? "" : ("; expires=" + LargeExpDate.toGMTString())) + "; path=/";
      },
      initGSWJ: function () {
        var webprefix = "http://szcert.ebs.org.cn/"
        var iconImageURL = "http://szcert.ebs.org.cn/Images/govIcon.gif";
        // var niconImageURL = "http://szcert.ebs.org.cn/Images/newGovIcon.gif";
        // 链接地址
        this.config.gswjUrl = webprefix + this.config.certId;
        // 图片SRC
        this.config.gswjImgSrc = iconImageURL;
        // 在页面加载完成后，获取信息并且异步post到cert.gov.com

      },

      ...mapMutations({
        setUserName: 'SET_USER_NAME',
        setUserId: 'SET_USER_ID',
        setLoginInfo: 'SET_LOGIN_INFO'
      })
    }
  }
</script>

<style lang="scss" scoped>
$bgColor: #0E3140;
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }

  $view-width: 1250px;

  .wrapper {
    min-width: $view-width;
    position: relative;
    height: 100vh;
    background-color: $bgColor !important;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .gradual-top {
    // position: absolute;
    // top: 0;
    // left: 0;
    background-color: $bgColor !important;
    width: 100%;
    height: 60px;
    z-index: 2;
  }

  .middle {
    padding-top: 30px;
    background-color: #FAFAFA;

    .title {
      text-align: center;
    }

    .title_en {
      text-align: center;
    }
  }

  .w-footer {
    background-color: $bgColor !important;
  }

  /* Demonstrate a "mostly customized" scrollbar
  * (won't be visible otherwise if width/height is specified) */

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    overflow: auto
  }

  ::-webkit-scrollbar-thumb {
    background-color: #e6e6e6;
    min-height: 25px;
    min-width: 25px;
    border: 1px solid #e0e0e0
  }

  ::-webkit-scrollbar-track {
    background-color: #f7f7f7;
    border: 1px solid #efefef
  }

  img.gswj {
    height: 18px;
    margin-right: 4px;
    vertical-align: middle;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all .5s ease-out;
  }

  .fade-enter,
  .fade-leave-to
  /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue